import { useTranslation } from "react-i18next";

export function useInstallationSideLabels() {
  const { t } = useTranslation();

  const getSideImageTitle = (side) => {
    if (side === "right") {
      return t("installation_side_image_right");
    }
    return t("installation_side_image_left");
  };

  const getRotationPageTitle = (side) => {
    if (side === "right") {
      return t("installation_rotation_page_title_right");
    }
    return t("installation_rotation_page_title_left");
  };

  const getMaskPageTitle = (side) => {
    if (side === "right") {
      return t("installation_mask_page_title_right");
    }
    return t("installation_mask_page_title_left");
  };

  return {
    getSideImageTitle,
    getRotationPageTitle,
    getMaskPageTitle,
  };
}

export function buildVisualizationSidePath(routeCameraId, side) {
  return `/app/installationdetails/${routeCameraId}/visualization/${side}`;
}
